<template>
    <span>
        <CompassLink
            v-for="(obj, index) in list"
            :key="index"
            :label="getLabel(obj.name, index)"
            :link="obj.link"
        >
        </CompassLink>
    </span>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getLabel(label, index) {
            return this.list.length > 1 && index + 1 < this.list.length ? `${label},` : label;
        },
    },
};
</script>
